import { render, staticRenderFns } from "./SKEntityDetails.vue?vue&type=template&id=31bc77bc&"
import script from "./SKEntityDetails.vue?vue&type=script&lang=js&"
export * from "./SKEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports